import { baseUrl } from "config/allFormats";
import { GeopuntLocation } from "types/types";

export function getWcsUrl(
  layerName: string,
  projectionUrl: string,
  location?: GeopuntLocation
) {
  const subsetX = `subset=X(${location?.BoundingBox.LowerLeft.X_Lambert72},${location?.BoundingBox.UpperRight.X_Lambert72})`;
  const subsetY = `subset=Y(${location?.BoundingBox.LowerLeft.Y_Lambert72},${location?.BoundingBox.UpperRight.Y_Lambert72})`;
  const outputCrs = `outputCRS=${projectionUrl}`;
  const subSettingCrs =
    "subsettingcrs=http://www.opengis.net/def/crs/EPSG/0/31370";

  if (location)
    return `${baseUrl}/wcs?service=WCS&version=2.0.0&request=GetCoverage&coverageId=${layerName}&${outputCrs}&${subsetX}&${subsetY}&${subSettingCrs}`;
  return `${baseUrl}/wcs?service=WCS&version=2.0.0&request=GetCoverage&coverageId=${layerName}&${outputCrs}`;
}

export function getShapefileUrl(
  layerName: string,
  projectionUrl: string,
  location?: GeopuntLocation
) {
  if (location) {
    return `${baseUrl}/wfs?service=WFS&version=2.0.0&request=GetFeature&typeNames=${layerName}&outputFormat=SHAPE-ZIP&srsName=EPSG:31370&bbox=${location.BoundingBox.LowerLeft.X_Lambert72},${location.BoundingBox.LowerLeft.Y_Lambert72},${location.BoundingBox.UpperRight.X_Lambert72},${location.BoundingBox.UpperRight.Y_Lambert72},EPSG:31370`;
  }
  return `${baseUrl}/wfs?service=wfs&version=2.0.0&request=GetFeature&typeNames=${layerName}&outputFormat=SHAPE-ZIP&srsName=${projectionUrl}`;
}
